<h2 mat-dialog-title>Internal Review</h2>
<div
  fxLayout="row"
  fxLayoutGap="5pt"
  fxLayoutAlign="start start"
  class="result-panel__details"
>
  <div
    fxFlex="60"
    fxLayout="column"
    fxLayoutGap="5pt"
    overflow="auto"
    height="10000vh"
  >
    <span><b>Comments: </b></span>

    <mat-table [dataSource]="dataSource" class="mat-elevation-z1" matSort>
      <ng-container matColumnDef="createUser">
        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
        <mat-cell *matCellDef="let review">{{ review.createUser }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="createDate">
        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
        <mat-cell *matCellDef="let review">
          {{ this.dateFormatCST(review.createDate) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="comment">
        <mat-header-cell *matHeaderCellDef>Comment</mat-header-cell>
        <mat-cell *matCellDef="let review">{{ review.comment }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
  </div>
  <form
    fxFlex="40"
    fxLayout="column"
    fxLayoutGap="5pt"
    [formGroup]="internalReviewForm"
  >
    <mat-form-field>
      <mat-label>Internal Review Status</mat-label>
      <mat-select formControlName="ManualAuditStatusID">
        <mat-option [value]="1">In Internal Review</mat-option>
        <mat-option [value]="2">Closed</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Comments</mat-label>
      <textarea matInput formControlName="Comment" required rows="5"></textarea>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5pt">
      <button mat-button type="button" color="warn" [mat-dialog-close]="false">
        <mat-icon class="material-icons-outlined">cancel</mat-icon>
        Exit
      </button>
      <button
        mat-button
        type="submit"
        color="accent"
        [disabled]="!internalReviewForm.valid"
        (click)="updateInternalReview()"
      >
        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
        Submit
      </button>
    </div>
  </form>
</div>
